/* eslint-disable react-hooks/exhaustive-deps */
import {
  Avatar,
  Badge,
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroup,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import {
  useDeleteCustomerImageMutation,
  useFindCustomerDetailByIdMutation,
  useUpdateCustomerDetailMutation,
  useUploadCustomerImageMutation,
} from "../../../redux/services/customerService";
import { getUserData } from "../../../redux/slices/authSlice";
import { REGEX_CONSTANT } from "../../../environment/AppConstants";
import toast from "react-hot-toast";
import Loading from "../../commons/Loading";
import MuiAlert from "../../MuiAlert/MuiAlert";
import { AiFillStar } from "react-icons/ai";
import { normalizeInput, roundNumber } from "../../../redux/services/utility";
import LocationSearchInput from "../../../components/GooglePlacesComponent/PlaceLocationAutoComplete";
import { RiImageEditFill } from "react-icons/ri";
import {
  selectCustomerData,
  setCustomer,
} from "../../../redux/slices/customerSlice";
import { useAppDispatch } from "../../../redux/app/hooks";
import { useGetAllCitiesMutation } from "../../../redux/services/cityApi";
import Iconify from "../../../components/Iconify";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { parseISO } from 'date-fns';
import editImage from "../../../assets/Edit pic@4x.png";

type Props = {};

const customerSchema = Yup.object().shape({
  name: Yup.string().required("Full name is required").min(3).max(30),
  phoneNo: Yup.string()
    .required("Phone number is required")
    .min(10, "Phone number must be 10 digits only")
    .max(10, "Phone number must be 10 digits only"),
  email: Yup.string().required("Email is required").email(),
  addressLine1: Yup.string().required("Address is required"),
  // city: Yup.string().required("City is required"),
  // pinCode: Yup.string()
  //   .required("Pincode is required")
  //   .matches(/^[0-9]+$/, "Pincode must be only digits")
  //   .min(6, "Pincode must be 6 digits only")
  //   .max(6, "Pincode must be 6 digits only"),
});

const Account = (props: Props) => {
  const userData = useSelector(getUserData);
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const customerId = currentUser?.customerId;
  const [findById, findByIdResponse] = useFindCustomerDetailByIdMutation();
  const [deleteCustomerImage, deleteCustomerImageResponse] =
    useDeleteCustomerImageMutation();
  // const customerData = useSelector(selectCustomerData);
  const customerData: any = JSON.parse(localStorage.getItem("customerDetail") || "{}");
  console.log(customerData ,"customerData");
  // city image ref
  const profileImageInput: any = useRef();
  // city image state
  const dispatch = useAppDispatch();
  const [profileImage, setProfileImage] = useState<null | any>();
  const [isImgUrl, setIsImgUrl] = useState(false);
  const [slabRate, setSlabRate] = useState();
  const [buck, setBuck]: any = useState();
  const [uploadImage, uploadImageResponse] = useUploadCustomerImageMutation();
  const [updateCustData, updateCustDataResponse] =
    useUpdateCustomerDetailMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [selectedState, setSelectedState] = useState(
    customerData?.state ? customerData?.state : ""
  ) as any;
  const [selectedCountry, setSelectedCountry] = useState(
    customerData?.country ? customerData?.country : ""
  ) as any;
  const [getAllCities, getAllCitiesResponse] = useGetAllCitiesMutation();
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [formValues, setFormValues] = useState({
    id: 0,
    merchantId: 0,
    userId: 0,
    name: "",
    dob: null,
    email: "",
    gender: "",
    addressLine1: null,
    addressLine2: null,
    imageUrl: null,
    preSignedImageUrl: null,
    phoneNo: "",
    vehicleRegistrationNumber: null,
    status: null,
    city: "",
    state: "",
    country: "",
    pinCode: null,
  });
  const country = customerData?.country;
  const name = customerData?.name;
  const address = customerData?.addressLine1;
  const email = customerData?.email;
  const mobileNo = customerData?.phoneNo;
  const city = customerData?.city;
  const state = customerData?.state;
  const pinCode = customerData?.pinCode;
  const dob = customerData?.dob;
  const gender = customerData?.gender;


  useEffect(() => {
    if (userData) {
      findById({ token: token, id: customerId });
    }
  }, []);

  useEffect(() => {
    getAllCities({
      token: token,
      payload: {
        offset: 1000,
        page: 0,
        status: true,
      },
    });
  }, []);

  let uniqueStateData: any = [];
  let uniqueCountryData: any = [];
  useEffect(() => {
    if (getAllCitiesResponse.isSuccess) {
      let cityData: any = [];
      let stateData: any = [];
      let countryData: any = [];
      getAllCitiesResponse?.data?.data.forEach((obj: any) => {
        cityData.push({
          name: obj.name,
          stateName: obj.stateName,
          countryName: obj.countryName,
        });
        stateData.push({
          stateName: obj.stateName,
        });
        countryData.push({
          countryName: obj.countryName,
        });
        uniqueStateData = stateData.filter(
          (obj: any, index: any) =>
            stateData.findIndex(
              (item: any) => item.stateName === obj.stateName
            ) === index
        );
        uniqueCountryData = countryData.filter(
          (obj: any, index: any) =>
            countryData.findIndex(
              (item: any) => item.countryName === obj.countryName
            ) === index
        );
      });
      setCityData(cityData);
      setStateData(uniqueStateData);
      setCountryData(uniqueCountryData);
    } else if (getAllCitiesResponse.isError) {
      toast.error("Can not get cities.");
    }
  }, [getAllCitiesResponse.isSuccess || getAllCitiesResponse.isError]);

  useEffect(() => {
    if (updateCustDataResponse.isSuccess) {
      findById({ token: token, id: customerId });
      let custData = findByIdResponse.data;
      setFormValues(custData);
      setIsImgUrl(true);
      setProfileImage(custData?.preSignedImageUrl);
      setSlabRate(custData.customerSlab);
      setBuck(custData.rewardBalance);
      setStatusCode({ type: "success", code: "UPDATE_ACCOUNT_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    } else if (updateCustDataResponse.isError) {
      customerData?.state
        ? setSelectedState(customerData?.state)
        : setSelectedState("");
      customerData?.country
        ? setSelectedCountry(customerData?.country)
        : setSelectedCountry("");
      let newmsg: any = updateCustDataResponse?.error;
      let msg = newmsg?.data.serviceErrors[0].msg;
      setStatusCode({ type: "error", code: msg });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [updateCustDataResponse.isSuccess, updateCustDataResponse.isError]);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      let custData = findByIdResponse.data;
      setFormValues(custData);
      setIsImgUrl(true);
      setProfileImage(custData?.preSignedImageUrl);
      setSlabRate(custData.customerSlab);
      setBuck(custData.rewardBalance);
      dispatch(setCustomer(findByIdResponse.data));
      localStorage.setItem(
        "customerDetail",
        JSON.stringify(findByIdResponse.data)
      );
      if (
        name === null ||
        email === null ||
        mobileNo === null ||
        country === null ||
        address === null ||
        city === null ||
        state === null ||
        dob === null ||
        gender === null ||
        pinCode === null
      ) {
        let msg = "Please complete your profile";
        setStatusCode({ type: "error", code: msg });
        setIsAlertVisible(true);
        setTimeout(() => {
          setIsAlertVisible(false);
        }, 5000);
      }
    } else if (findByIdResponse.isError) {
      let newmsg: any = findByIdResponse?.error;
      let msg = newmsg?.data?.serviceErrors[0]?.msg;
      setStatusCode({ type: "error", code: msg });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [findByIdResponse.isSuccess, findByIdResponse.isError]);

  useEffect(() => {
    if (customerData) {
      console.log(customerData, "customerData");
      setFormValues({
        id: customerData.id === null ? 0 : customerData.id,
        merchantId:
          customerData.merchantId === null ? 0 : customerData.merchantId,
        userId: customerData.userId === null ? 0 : customerData.userId,
        name: customerData.name === null ? "" : customerData.name,
        dob: customerData.dob === null ? "" : customerData.dob,
        email: customerData.email === null ? "" : customerData.email,
        gender: customerData.gender === null ? "" : customerData.gender,
        addressLine1:
          customerData.addressLine1 === null ? "" : customerData.addressLine1,
        addressLine2:
          customerData.addressLine2 === null ? "" : customerData.addressLine2,
        imageUrl: customerData.imageUrl === null ? "" : customerData.imageUrl,
        preSignedImageUrl:
          customerData.preSignedImageUrl === null
            ? ""
            : customerData.preSignedImageUrl,
        phoneNo: customerData.phoneNo === null ? "" : customerData.phoneNo,
        vehicleRegistrationNumber:
          customerData.vehicleRegistrationNumber === null
            ? ""
            : customerData.vehicleRegistrationNumber,
        status: customerData.status === null ? "" : customerData.status,
        city: customerData.city === null ? "" : customerData.city,
        state: customerData.state === null ? "" : customerData.state,
        country: customerData.country === null ? "" : customerData.country,
        pinCode: customerData.pinCode === null ? "" : customerData.pinCode,
      });

      console.log("Form Values after setting:", formValues);

      setIsImgUrl(true);
      setProfileImage(customerData?.preSignedImageUrl);
    }
  }, [customerData]);

  useEffect(() => {
    if (uploadImageResponse.isSuccess) {
      findById({ token: token, id: customerId });
      setStatusCode({ type: "success", code: "PROFILE_UPDATE_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [uploadImageResponse.isSuccess || uploadImageResponse.isError]);

  const uploadImageData = (event: any) => {
    if (isImgUrl) {
      setIsImgUrl(false);
    }
    let profImage = event.target.files[0];
    setProfileImage(profImage);
    const formData = new FormData();
    formData.append("file", profImage);
    uploadImage({
      token: token,
      payload: formData,
      id: customerId,
      docType: "profile",
    });
  };

  const updateCustomerData = async (values: any, action: any) => {
    await updateCustData({
      payload: {
        id: customerData.id === null ? 0 : customerData.id,
        merchantId:
          customerData.merchantId === null ? 0 : customerData.merchantId,
        userId: customerData.userId == null ? 0 : customerData.userId,
        imageUrl: customerData.imageUrl === null ? "" : customerData.imageUrl,
        preSignedImageUrl:
          customerData.preSignedImageUrl === null
            ? ""
            : customerData.preSignedImageUrl,
        vehicleRegistrationNumber:
          customerData.vehicleRegistrationNumber === null
            ? ""
            : customerData.vehicleRegistrationNumber,
        addressLine1: values.addressLine1,
        addressLine2: values.addressLine2,
        email: values.email,
        name: values.name,
        dob: values.dob,
        gender: values.gender,
        phoneNo: values.phoneNo,
        status: customerData.status === null ? "" : customerData.status,
        city: values.city,
        state: values.state,
        country: values.country,
        pinCode: values.pinCode,
      },
      token: token,
    });

    console.log("Form Values after update:", values);

    action.resetForm();
    handleClose();
  };

  const removeProfile = () => {
    deleteCustomerImage({
      token: token,
      id: customerId,
    });
  };

  useEffect(() => {
    if (deleteCustomerImageResponse.isSuccess) {
      setStatusCode({ type: "success", code: "PROFILE_REMOVE_SUCCESS" });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
      findById({ token: token, id: customerId });
    }
    if (deleteCustomerImageResponse.isError) {
      let errorData: any = deleteCustomerImageResponse?.error;
      let errorMessage = errorData?.error;
      setStatusCode({
        type: "error",
        code: errorMessage,
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [
    deleteCustomerImageResponse.isSuccess,
    deleteCustomerImageResponse.isError,
  ]);

  const handleSelectStateCountry = (cityName: any) => {
    cityData.map((cityData: any) => {
      if (cityName == cityData.name) {
        setSelectedState(cityData.stateName);
        setSelectedCountry(cityData.countryName);
      }
    });
  };

  const locationChange = (item: any) => {
    setFormValues({
      ...formValues,
      city: item.city,
      state: item.state,
      country: item.country,
      pinCode:item.pinCode,
    });
  };


  const styleActiveModel = {
    position: "absolute" as "absolute",
    top: "52%",
    left: "47%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "10px",
    p: "40px",
    px: "40px",
  };

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState(false) as any;

  const handleClose = () => {
    setOpen(false);
  };

  const renderField = (label: any, value: any, onAddClick: React.MouseEventHandler<HTMLButtonElement> | undefined) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        borderBottom: "1px solid #e0e0e0",
        padding: "8px 0",
        marginBottom: "16px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: "16px", color: "#000" }}>
          {label}
        </span>
        {value ? (
          <span style={{ fontSize: "16px", fontWeight: "bold", color: "#000" }}>
            {value}
          </span>
        ) : (
          <Button
            variant="text"
            startIcon={<Iconify icon="eva:plus-outline" sx={undefined} />}
            onClick={() => {
              setMode(false);
              setOpen(true);
            }}
            style={{
              textTransform: "none",
              color: "#1E90FF",
              fontWeight: "bold",
            }}
          >
            Add
          </Button>
        )}
      </div>
    </div>

  );

  return (
    <div className=" rounded-[8px] bg-[#F9F4EF] lg:mx-[20px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:px-[100px] lg:py-10">
      {findByIdResponse.isLoading || uploadImageResponse.isLoading ? (
        <Loading />
      ) : (
        <div className="col-span-9 content-center items-center justify-center mr-30 ">
          {isAlertVisible && (
            <div>
              <MuiAlert
                severity={statusCode?.type!}
                messageType={statusCode?.code!}
              />
            </div>
          )}
          <div className="flex lg:flex-row md:flex-row flex-col justify-between items-center w-full">
            <div className="flex lg:flex-row md:flex-row flex-col items-center gap-6">
              <div className="flex flex-col items-center">
                <input
                  type="file"
                  name="city-image"
                  id="city-image"
                  ref={profileImageInput}
                  className="hidden"
                  accept="image/gif, image/jpeg, image/png"
                  onChange={uploadImageData}
                />
                <div className="p-1 border-[3px] border-red-500 rounded-full">
                  <Box
                    onClick={() => profileImageInput.current.click()}
                    className="cursor-pointer"
                  >
                    {profileImage ? (
                      <Box className="relative">
                        <Badge
                          overlap="circular"
                          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                          badgeContent={
                            <img src={editImage} className="w-5 h-5" />
                          }
                        >
                          <Avatar
                            src={isImgUrl ? profileImage : URL.createObjectURL(profileImage)}
                            sx={{
                              width: 80,
                              height: 80,
                            }}
                          />
                        </Badge>
                      </Box>
                    ) : (
                      <Badge
                        overlap="circular"
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        badgeContent={
                          <img src={editImage} className="w-5 h-5" />
                        }
                      >
                        <Box
                          onClick={() => profileImageInput.current.click()}
                          className="flex items-center justify-center text-center"
                          style={{
                            background: "lightgray",
                            height: 80,
                            width: 80,
                            borderRadius: "50%",
                          }}
                        ></Box>
                      </Badge>
                    )}
                  </Box>
                </div>

                {/* Remove Button 
                <Button
                  color="error"
                  variant="contained"
                  disabled={profileImage === null}
                  onClick={removeProfile}
                  startIcon={<Iconify icon="material-symbols-light:cancel-outline" width="24" height="24" sx={undefined}/>}
                  size="medium"
                  className="mt-3"
                >
                  Remove
                </Button> */}
              </div>

              <div className="lg:mt-5 md:mt-5">
                <p className="lg:text-left md:text-left text-center text-[#434343] font-bold lg:text-[25px] text-[26px]">
                  Personal Details
                </p>
                <p className="lg:text-left md:text-left text-center text-sm text-black-500 mb-5">
                  Basic info, for a faster booking experience
                </p>
              </div>
            </div>

            {/**<Button
              onClick={() => {
                setMode(false);
                setOpen(true);
              }}
              startIcon={<Iconify icon="eva:edit-outline" sx={undefined}/>}
              style={{
                color: "#1E90FF",
                backgroundColor: "transparent",
                borderRadius: "4px",
                padding: "5px 10px",
                textTransform: "none",
                fontSize: "14px",
                fontWeight: "bold",
                whiteSpace: "nowrap",
              }}
              size="small"
            >
              Edit
            </Button> */}
          </div>
          <div className="lg:flex lg:flex-row rounded-lg h-3/4 justify-center">
            <div className="mt-12 w-full">
              <Formik
                enableReinitialize
                initialValues={formValues}
                onSubmit={updateCustomerData}
                validationSchema={customerSchema}
              >
                {({
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  setFieldValue,
                  values,
                  touched,
                  errors,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      {/* Name */}
                      <div className="md:col-span-2 col-span-1">
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Full Name</label>
                        <TextField
                          fullWidth
                          autoComplete="name"
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(touched.name && errors.name)}
                          helperText={touched.name && errors.name}
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px", // Slightly reduced height for a compact look
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center", // Centers input text vertically
                              height: "100%",
                              padding: "0 12px", // Reducing padding inside input container
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              "& input": {
                                padding: "6px 8px", // Reduced padding inside input field
                              },
                              "& fieldset": { borderColor: "transparent" },
                              "&:hover fieldset": { borderColor: "transparent" },
                              "&.Mui-focused fieldset": { borderColor: "transparent" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px", // Moves label closer to start
                              transform: "translateY(-50%)", // Centers label vertically
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6, // Moves label up when focused
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px", // Adjusted for better spacing
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>

                      {/* Date of Birth */}
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Date of Birth</label>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DatePicker
                            value={values.dob ? new Date(values.dob) : null}
                            onChange={(date) => setFieldValue("dob", date)}
                            sx={{
                              backgroundColor: "#E2E2E2",
                              borderRadius: "30px",
                              mb: 2,
                              height: "45px", // Slightly reduced height for a compact look
                              "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                              },
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                  padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                              },
                              "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                              },
                              "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                              },
                              "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                              },
                            }}
                            slotProps={{
                              textField: {
                                id: "dob",
                                name: "dob",
                                fullWidth: true,
                                error: Boolean(touched.dob && errors.dob),
                                helperText: touched.dob && errors.dob,
                                className:
                                  "rounded-full p-2 bg-gray-200 border-none shadow-none outline-none",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      {/* Phone Number */}
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Phone Number</label>
                        <TextField
                          fullWidth
                          type="text"
                          name="phoneNo"
                          id="phoneNo"
                          value={values.phoneNo}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={Boolean(touched.phoneNo && errors.phoneNo)}
                          helperText={touched.phoneNo && errors.phoneNo}
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px", // Slightly reduced height for a compact look
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center", // Centers input text vertically
                              height: "100%",
                              padding: "0 12px", // Reducing padding inside input container
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              "& input": {
                                padding: "6px 8px", // Reduced padding inside input field
                              },
                              "& fieldset": { borderColor: "transparent" },
                              "&:hover fieldset": { borderColor: "transparent" },
                              "&.Mui-focused fieldset": { borderColor: "transparent" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px", // Moves label closer to start
                              transform: "translateY(-50%)", // Centers label vertically
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6, // Moves label up when focused
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px", // Adjusted for better spacing
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>

                      {/* Gender */}
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Gender</label>
                        <FormControl fullWidth>
                          <Select
                            labelId="gender-label"
                            id="gender"
                            name="gender"
                            value={values.gender || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            className="rounded-full bg-gray-200 p-2"
                            sx={{
                              backgroundColor: "#E2E2E2",
                              borderRadius: "30px",
                              mb: 2,
                              height: "45px",
                              "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center",
                                height: "100%",
                                padding: "0 12px",
                              },
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                boxShadow: "none", // Removes any shadow effect
                                "& input": {
                                  padding: "6px 8px",
                                },
                                "& fieldset": { border: "none" }, // Removes the border completely
                                "&:hover fieldset": { border: "none" },
                                "&.Mui-focused fieldset": { border: "none" },
                                "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Ensures no outline
                              },
                              "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px",
                                transform: "translateY(-50%)",
                              },
                              "& .MuiInputLabel-shrink": {
                                top: 6,
                                transform: "translateY(-100%) scale(0.75)",
                              },
                              "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px",
                                fontSize: "12px",
                                color: "red",
                              },
                            }}
                            MenuProps={{
                              PaperProps: {
                                sx: {
                                  borderRadius: "12px",
                                  overflow: "hidden",
                                },
                              },
                            }}
                          >
                            <MenuItem value="Male">Male</MenuItem>
                            <MenuItem value="Female">Female</MenuItem>
                            <MenuItem value="Other">Other</MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      {/* Email */}
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Email</label>
                        <TextField
                          fullWidth
                          disabled
                          name="email"
                          id="email"
                          value={values.email}
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px",
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              padding: "0 12px",
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              boxShadow: "none", // Ensures no shadow effect
                              "& input": {
                                padding: "6px 8px",
                              },
                              "& fieldset": { border: "none" }, // Completely removes the border
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px",
                              transform: "translateY(-50%)",
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6,
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px",
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>

                      {/* Address */}
                      <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Address Line 1 */}
                        <div className="w-full">
                          <label className="text-sm block font-semibold text-gray-800 mb-1">Address Line 1</label>
                          <TextField
                            fullWidth
                            type="text"
                            name="addressLine1"
                            id="addressLine1"
                            value={values.addressLine1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.addressLine1 && errors.addressLine1)}
                            helperText={touched.addressLine1 && errors.addressLine1}
                            sx={{
                              backgroundColor: "#E2E2E2",
                              borderRadius: "30px",
                              mb: 2,
                              height: "45px", // Slightly reduced height for a compact look
                              "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                              },
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                  padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                              },
                              "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                              },
                              "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                              },
                              "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                              },
                            }}
                          />
                        </div>

                        {/* Address Line 2 */}
                        <div className="w-full">
                          <label className="text-sm block font-semibold text-gray-800 mb-1">Address Line 2</label>
                          <TextField
                            fullWidth
                            autoComplete="addressLine2"
                            type="text"
                            name="addressLine2"
                            id="addressLine2"
                            value={values.addressLine2}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.addressLine2 && errors.addressLine2)}
                            helperText={touched.addressLine2 && errors.addressLine2}
                            sx={{
                              backgroundColor: "#E2E2E2",
                              borderRadius: "30px",
                              mb: 2,
                              height: "45px", // Slightly reduced height for a compact look
                              "& .MuiInputBase-root": {
                                display: "flex",
                                alignItems: "center", // Centers input text vertically
                                height: "100%",
                                padding: "0 12px", // Reducing padding inside input container
                              },
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "30px",
                                height: "100%",
                                "& input": {
                                  padding: "6px 8px", // Reduced padding inside input field
                                },
                                "& fieldset": { borderColor: "transparent" },
                                "&:hover fieldset": { borderColor: "transparent" },
                                "&.Mui-focused fieldset": { borderColor: "transparent" },
                              },
                              "& .MuiInputLabel-root": {
                                top: "50%",
                                left: "12px", // Moves label closer to start
                                transform: "translateY(-50%)", // Centers label vertically
                              },
                              "& .MuiInputLabel-shrink": {
                                top: 6, // Moves label up when focused
                                transform: "translateY(-100%) scale(0.75)",
                              },
                              "& .MuiFormHelperText-root": {
                                position: "absolute",
                                bottom: "-18px", // Adjusted for better spacing
                                fontSize: "12px",
                                color: "red",
                              },
                            }}
                          />
                        </div>
                      </div>
                      <div className="md:col-span-2 col-span-1">
                        <label className="text-sm block font-semibold text-gray-800 mb-1"> Search Location</label>
                        <LocationSearchInput locationDetail={(item: any) => locationChange(item)} value={""} />
                      </div>
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Pincode</label>
                        <TextField
                          fullWidth
                          autoComplete="pinCode"
                          name="pinCode"
                          id="pinCode"
                          value={values.pinCode }
                          onChange={handleChange} // ✅ Added to allow typing
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px",
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              padding: "0 12px",
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              "& input": {
                                padding: "6px 8px",
                              },
                              "& fieldset": { borderColor: "transparent" },
                              "&:hover fieldset": { borderColor: "transparent" },
                              "&.Mui-focused fieldset": { borderColor: "transparent" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px",
                              transform: "translateY(-50%)",
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6,
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px",
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">City</label>
                        <TextField
                          fullWidth
                          disabled
                          autoComplete="city"
                          type="text"
                          name="city"
                          id="city"
                          value={values.city}
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px",
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              padding: "0 12px",
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              boxShadow: "none", // Ensures no shadow effect
                              "& input": {
                                padding: "6px 8px",
                              },
                              "& fieldset": { border: "none" }, // Completely removes the border
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px",
                              transform: "translateY(-50%)",
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6,
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px",
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">State</label>
                        <TextField
                          fullWidth
                          disabled
                          autoComplete="state"
                          type="text"
                          name="state"
                          id="state"
                          value={values.state }
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px",
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              padding: "0 12px",
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              boxShadow: "none", // Ensures no shadow effect
                              "& input": {
                                padding: "6px 8px",
                              },
                              "& fieldset": { border: "none" }, // Completely removes the border
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px",
                              transform: "translateY(-50%)",
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6,
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px",
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>
                      <div>
                        <label className="text-sm block font-semibold text-gray-800 mb-1">Country</label>
                        <TextField
                          fullWidth
                          disabled
                          autoComplete="country"
                          type="text"
                          name="country"
                          id="country"
                          value={values.country}
                          sx={{
                            backgroundColor: "#E2E2E2",
                            borderRadius: "30px",
                            mb: 2,
                            height: "45px",
                            "& .MuiInputBase-root": {
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                              padding: "0 12px",
                            },
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "30px",
                              height: "100%",
                              boxShadow: "none", // Ensures no shadow effect
                              "& input": {
                                padding: "6px 8px",
                              },
                              "& fieldset": { border: "none" }, // Completely removes the border
                              "&:hover fieldset": { border: "none" },
                              "&.Mui-focused fieldset": { border: "none" },
                            },
                            "& .MuiInputLabel-root": {
                              top: "50%",
                              left: "12px",
                              transform: "translateY(-50%)",
                            },
                            "& .MuiInputLabel-shrink": {
                              top: 6,
                              transform: "translateY(-100%) scale(0.75)",
                            },
                            "& .MuiFormHelperText-root": {
                              position: "absolute",
                              bottom: "-18px",
                              fontSize: "12px",
                              color: "red",
                            },
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex justify-center items-center mt-5">
                      <button
                        // onClick={() => handleSubmit()}
                        type="submit"
                        className="bg-[#ED1C24] text-white px-6 py-2 rounded-full hover:bg-[#ED1C24]">
                        Save Changes
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
            {/*<div className="mt-12 w-full">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
               
                <div className="md:col-span-2 col-span-1">
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Name</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.name}</div>
                </div>
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Date of Birth</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.dob}</div>
                </div>

               
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Phone Number</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.phoneNo}</div>
                </div>
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Gender</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.gender}</div>
                </div>
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Email</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full overflow-hidden whitespace-nowrap text-ellipsis">{formValues.email}</div>
                </div>

                
                <div className="md:col-span-2 col-span-1">
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Address</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full overflow-hidden whitespace-nowrap text-ellipsis">{formValues.addressLine1} {formValues.addressLine2}</div>
                </div>
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Pincode</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.pinCode}</div>
                </div>

           
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">City</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.city}</div>
                </div>
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">State</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.state}</div>
                </div>
                <div>
                  <label className="text-sm block font-semibold text-gray-800 mb-1">Country</label>
                  <div className="text-sm bg-gray-200 rounded-full p-2 w-full">{formValues.country}</div>
                </div>
              </div>
            </div> */}
            {/*<Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box sx={styleActiveModel} style={{ overflowY: "auto", height: "70%" ,backgroundColor: "#F9F4EF"}} border={1} borderRadius={2} borderColor={"white"}>
              <Formik
                  enableReinitialize
                  initialValues={formValues}
                  onSubmit={updateCustomerData}
                  validationSchema={customerSchema}
                >
                  {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    values,
                    touched,
                    errors,
                  }) => (
                    <div className="lg:mx-[30px]">
                      <h2 className="font-semibold text-[#434343] text-[16px] lg:text-[20px]">
                        Personal Details
                      </h2>

                      <Box className="mt-5 md:flex items-center justify-between">
                        <Box className="w-full mr-5">
                          <TextField
                            fullWidth
                            autoComplete="name"
                            type="text"
                            name="name"
                            id="name"
                            label="Full Name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .Mui-disabled": {
                                pointerEvents: "none",
                                opacity: 1, // Prevents default MUI disabled styling
                              }
                            }}
                          />
                        </Box>
                        <Box className="w-full mt-[32px] md:mt-0">
                          <TextField
                            fullWidth
                            type="text"
                            name="phoneNo"
                            id="phoneNo"
                            label="Phone number"
                            value={values.phoneNo}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.phoneNo && errors.phoneNo)}
                            helperText={touched.phoneNo && errors.phoneNo}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .Mui-disabled": {
                                pointerEvents: "none",
                                opacity: 1, // Prevents default MUI disabled styling
                              }
                            }}
                          />
                        </Box>
                      </Box>

                      <Box className="mt-5 md:flex items-center justify-between">
                      <Box className="w-full mr-5">
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              value={values.dob ? new Date(values.dob) : null}
                              onChange={(date) => setFieldValue("dob", date)}
                              sx={{
                                "& .MuiInputBase-root": {
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  backgroundColor: "#E5E7EB",
                                  borderRadius: "999px",
                                },
                                "& .MuiOutlinedInput-root": {
                                  all: "unset", 
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                },
                                "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                  all: "unset", 
                                  flex: 1, 
                                  minWidth: 0, 
                                  color: "#333",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "& .Mui-disabled": {
                                  pointerEvents: "none",
                                  opacity: 1,
                                },
                                "& .MuiSvgIcon-root": {
                                  color: "#333",
                                },
                              }}
                              slotProps={{
                                textField: {
                                  id: "dob",
                                  name: "dob",
                                  label: "Date of Birth",
                                  fullWidth: true,
                                  error: Boolean(touched.dob && errors.dob),
                                  helperText: touched.dob && errors.dob,
                                  className:
                                    "rounded-full p-2 bg-gray-200 border-none shadow-none outline-none",
                                },
                              }}
                            />
                          </LocalizationProvider>
                        </Box>

                        <Box className="w-full">
                          <FormLabel className="text-sm">Gender</FormLabel>
                          <RadioGroup row name="gender" value={values.gender || ""} onChange={handleChange}>
                            <FormControlLabel value="Male" control={<Radio />} label="Male" />
                            <FormControlLabel value="Female" control={<Radio />} label="Female" />
                          </RadioGroup>
                        </Box>
                      </Box>

                      <Box className="mt-5 md:flex items-center justify-between">
                        <Box className="w-full mr-5">
                          <TextField
                            fullWidth
                            autoComplete="email"
                            type="text"
                            name="email"
                            id="email"
                            disabled
                            label="Email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.email && errors.email)}
                            helperText={touched.email && errors.email}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", 
                              },
                              "& .Mui-disabled": {
                                color: "#9CA3AF", 
                                cursor: "not-allowed",
                                opacity: 1,
                                pointerEvents: "none",
                              },
                              "& .Mui-disabled .MuiInputBase-input": {
                                backgroundColor: "#E5E7EB", 
                              },
                              "& .MuiInputLabel-root.Mui-disabled": {
                                backgroundColor: "transparent", 
                              }
                            }}
                          />
                        </Box>
                        <Box className="w-full mt-[32px] md:mt-0">
                          <TextField
                            fullWidth
                            type="text"
                            name="addressLine1"
                            id="addressLine1"
                            label="Address Line 1"
                            value={values.addressLine1}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.addressLine1 && errors.addressLine1)}
                            helperText={touched.addressLine1 && errors.addressLine1}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .Mui-disabled": {
                                pointerEvents: "none",
                                opacity: 1,
                              }
                            }}
                          />
                        </Box>
                      </Box>

                      <Box className="mt-5 md:flex items-center justify-between">
                        <Box className="w-full mr-5">
                          <TextField
                            fullWidth
                            autoComplete="addressLine2"
                            type="text"
                            name="addressLine2"
                            id="addressLine2"
                            label="Address Line 2"
                            value={values.addressLine2}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={Boolean(touched.addressLine2 && errors.addressLine2)}
                            helperText={touched.addressLine2 && errors.addressLine2}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .Mui-disabled": {
                                pointerEvents: "none",
                                opacity: 1, 
                              }
                            }}
                          />
                        </Box>
                        <Box className="w-full mt-[32px] md:mt-0">
                          <LocationSearchInput locationDetail={(item: any) => locationChange(item)} value={values.city} />
                        </Box>
                      </Box>

                      <Box className="mt-5 md:flex items-center justify-between">
                        <Box className="w-full mr-5">
                          <TextField
                            fullWidth
                            disabled
                            autoComplete="city"
                            type="text"
                            name="city"
                            id="city"
                            label="City"
                            value={values.city || custaddress.city || ""}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", 
                              },
                              "& .Mui-disabled": {
                                color: "#9CA3AF", 
                                cursor: "not-allowed",
                                opacity: 1,
                                pointerEvents: "none",
                              },
                              "& .Mui-disabled .MuiInputBase-input": {
                                backgroundColor: "#E5E7EB", 
                              },
                              "& .MuiInputLabel-root.Mui-disabled": {
                                backgroundColor: "transparent", 
                              }
                            }}
                          />
                        </Box>
                        <Box className="w-full mt-[32px] md:mt-0">
                          <TextField
                            fullWidth
                            disabled
                            autoComplete="state"
                            type="text"
                            name="state"
                            id="state"
                            label="State"
                            value={values.state || custaddress.state || ""}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", 
                              },
                              "& .Mui-disabled": {
                                color: "#9CA3AF", 
                                cursor: "not-allowed",
                                opacity: 1,
                                pointerEvents: "none",
                              },
                              "& .Mui-disabled .MuiInputBase-input": {
                                backgroundColor: "#E5E7EB", 
                              },
                              "& .MuiInputLabel-root.Mui-disabled": {
                                backgroundColor: "transparent",
                              }
                            }}
                          />
                        </Box>
                      </Box>

                      <Box className="mt-5 md:flex items-center justify-between">
                        <Box className="w-full mr-5">
                          <TextField
                            fullWidth
                            disabled
                            autoComplete="country"
                            type="text"
                            name="country"
                            id="country"
                            label="Country"
                            value={values.country || custaddress.country || ""}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none", 
                              },
                              "& .Mui-disabled": {
                                color: "#9CA3AF", // Keeps text muted
                                cursor: "not-allowed",
                                opacity: 1,
                                pointerEvents: "none",
                              },
                              "& .Mui-disabled .MuiInputBase-input": {
                                backgroundColor: "#E5E7EB", // Apply background only to input field
                              },
                              "& .MuiInputLabel-root.Mui-disabled": {
                                backgroundColor: "transparent", // Ensures label does not get background
                              }
                            }}
                          />
                        </Box>
                        <Box className="w-full mt-[32px] md:mt-0">
                          <TextField
                            fullWidth
                            autoComplete="pinCode"
                            name="pinCode"
                            id="pinCode"
                            label="Pincode"
                            value={values.pinCode || custaddress.pinCode || ""}
                            className="rounded-full p-2 bg-gray-200 border-none shadow-none outline-none"
                            sx={{
                              "& .MuiInputBase-root, & .MuiOutlinedInput-root": {
                                all: "unset",
                              },
                              "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
                                all: "unset",
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                              },
                              "& .Mui-disabled": {
                                pointerEvents: "none",
                                opacity: 1, 
                              }
                            }}
                          />
                        </Box>
                      </Box>

                      <Box className="flex flex-col md:flex-row justify-center md:justify-end my-6 gap-4">
                        <Button variant="contained" color="error" size="large" className="rounded-full text-sm p-2 w-full md:w-auto" onClick={() => {
                            handleClose();
                          }}>
                          Cancel
                        </Button>
                        <Button variant="contained" color="error" size="large" className="rounded-full text-sm p-2 w-full md:w-auto" onClick={() => handleSubmit()}>
                          Save Changes
                        </Button>
                      </Box>
                    </div>
                  )}
                </Formik>
              </Box>
            </Modal> */}
          </div>
        </div>

      )}
    </div>
  );
};

export default Account;
